import React from 'react';

const CTASection = () => {
  return (
    <section className="bg-gray-900 py-20 md:py-24">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-white mb-4">
          Un projet ? Parlons-en.
        </h2>
        <p className="text-gray-400 mb-10 max-w-xl mx-auto">
          Nous sommes à votre écoute pour étudier vos besoins et vous proposer des solutions adaptées.
        </p>

        <a
          href="#contact"
          onClick={(e) => {
            e.preventDefault();
            document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="inline-block bg-white text-gray-900 font-medium text-sm px-8 py-3 rounded hover:bg-gray-100 transition-colors duration-200"
        >
          Contact
        </a>
      </div>
    </section>
  );
};

export default CTASection;
